import { whiteSpace } from "../custom";
import { color, layout, space, typography } from 'styled-system';
import { styled } from "../utils";
var Text = styled.p(typography, color, space, layout, whiteSpace);
Text.defaultProps = {
    color: 'primary',
    fontSize: ['small', 'normal'],
    fontFamily: 'primary',
    fontWeight: 'medium',
    letterSpacing: 'normal',
    lineHeight: 'normal',
};
export default Text;
//# sourceMappingURL=Text.js.map